import Phaser from 'phaser';

const ROCKET_SPEED = 600; // px/s

export class Rocket extends Phaser.GameObjects.Triangle {
  velocityX: number = 0;
  velocityY: number = 0;
  private distanceTravelled: number = 0;
  private maxRange: number = 800;
  private onExplode: (x: number, y: number) => void;
  private mapWidth: number;
  private mapHeight: number;

  constructor(
    scene: Phaser.Scene,
    fromX: number,
    fromY: number,
    toX: number,
    toY: number,
    mapWidth: number,
    mapHeight: number,
    onExplode: (x: number, y: number) => void
  ) {
    // Triangle pointing up, will be rotated
    super(scene, fromX, fromY, 0, -8, 4, 6, -4, 6, 0xff6600);
    this.mapWidth = mapWidth;
    this.mapHeight = mapHeight;
    this.onExplode = onExplode;

    scene.add.existing(this);
    this.setDepth(35);
    this.setStrokeStyle(1, 0xff2200);

    const angle = Phaser.Math.Angle.Between(fromX, fromY, toX, toY);
    this.setRotation(angle + Math.PI / 2);
    this.velocityX = Math.cos(angle) * ROCKET_SPEED;
    this.velocityY = Math.sin(angle) * ROCKET_SPEED;
  }

  update(delta: number): boolean {
    if (!this.active) return false;

    const dt = delta / 1000;
    const dx = this.velocityX * dt;
    const dy = this.velocityY * dt;

    this.x += dx;
    this.y += dy;
    this.distanceTravelled += Math.sqrt(dx * dx + dy * dy);

    const offMap =
      this.x < 0 || this.y < 0 || this.x > this.mapWidth || this.y > this.mapHeight;

    if (this.distanceTravelled >= this.maxRange || offMap) {
      this.triggerExplosion();
      return false;
    }

    return true;
  }

  triggerExplosion(): void {
    if (!this.active) return;
    const ex = this.x;
    const ey = this.y;
    this.destroy();
    this.onExplode(ex, ey);
  }
}
